import { jsx as _jsx } from "react/jsx-runtime";
var Book = function Book(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.58579 3.58579C4.96086 3.21071 5.46957 3 6 3H9H17C17.7956 3 18.5587 3.31607 19.1213 3.87868C19.6839 4.44129 20 5.20435 20 6V18C20 18.7957 19.6839 19.5587 19.1213 20.1213C18.5587 20.6839 17.7957 21 17 21H10V22C10 22.5523 9.55228 23 9 23C8.44772 23 8 22.5523 8 22V21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V5C4 4.46957 4.21071 3.96086 4.58579 3.58579ZM10 19H17C17.2652 19 17.5196 18.8946 17.7071 18.7071C17.8946 18.5196 18 18.2652 18 18V6C18 5.73478 17.8946 5.48043 17.7071 5.29289C17.5196 5.10536 17.2652 5 17 5H10V19ZM8 5V19H6L6 5L8 5ZM12 8C12 7.44772 12.4477 7 13 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H13C12.4477 9 12 8.55228 12 8ZM13 11C12.4477 11 12 11.4477 12 12C12 12.5523 12.4477 13 13 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H13Z",
      fill: color
    })
  });
};
export default Book;